import axios from "axios";
import {store} from "./configureStore";
import * as userActions from "./actions/user";
import AxiosConfig from "./AxiosConfig";
import i18n from "./i18n";

axios.interceptors.response.use(
  null,
  function (error) {
    if (error.response.status === 401) {
      AxiosConfig.setAuthToken(null);
      store.dispatch(userActions.logout());
      Snackbar.show({
        showAction: false,
        text: i18n.t('expired_session_message'),
        actionText: i18n.t('dismiss'),
      });
    }
    return Promise.reject(error);
  }
);

export default axios;
